import { normalizeGeneralQuoteItemImages, syncGeneralQuoteItemPrimaryImageFields } from '../components/generalQuotationUtils';

export const replaceGeneralQuoteItemImages = (item, images) => {
  // Explicit edits replace the image set; stale legacy aliases must not restore it.
  // Ordinary legacy hydration and the shared financial runtime remain unchanged.
  const normalized = normalizeGeneralQuoteItemImages({ images });
  const attachments = (Array.isArray(item.attachments) ? item.attachments : []).filter(entry =>
    normalizeGeneralQuoteItemImages({ attachments: [entry] }).length === 0);
  return syncGeneralQuoteItemPrimaryImageFields({
    ...item, images: normalized, itemImages: [], productImages: [], referenceImages: [], attachments,
    image: null, imageData: null, referenceImage: null, productImage: null,
    imageId: normalized[0]?.id || '', imageURL: '', downloadURL: '', downloadUrl: '',
    imageUrl: '', imageStoragePath: '', imageName: '', imagePreviewName: '',
    fullPath: '', storagePath: '', path: '', filePath: '', gsUrl: '', gsURL: '', filename: '',
  });
};
